import React from "react";
import {
  Router,
  RouteComponentProps,
  Redirect,
  globalHistory,
} from "@reach/router";
import PageLogin from "./components/page-login";
import PageUser from "./components/page-user";
import PageRegister from "./components/page-register";
import { IntlProvider } from "react-intl";
import localeData from "./locale-data/locales/intl.json";
// import LoggedOutRoute from "./components/logged-out-route/LoggedOutRoute";
import ProtectedRoute from "./components/protected-route";
import PageDashboard from "./components/page-dashboard";
import ResponsiveLayout from "./components/responsive-layout/ResponsiveLayout";
// import PageProfiles from "./components/page-profiles/PageProfiles";
// import PageProfileView from "./components/page-view-profile/PageViewProfile";
import useAuthContext from "./hooks/useAuthContext";
import useLocaleContext from "./hooks/useLocaleContext";
// import PageCreateProfile from "./components/page-create-profile";
import { CssBaseline } from "@material-ui/core";
import PagePeople from "./components/page-people";
import PageSendResetPassword from "./components/page-send-reset-password";
import PageResetPassword from "./components/page-reset-password";
import { QueryParamProvider } from "use-query-params";
import { Permission } from "./components/auth-context-provider";
import PageNewPlayer from "./components/page-new-player";
import PageNewTeam from "./components/page-new-team";
import PageNewMatch from "./components/page-new-match";
import PageNewExercise from "./components/page-new-exercise";
import { DrillGenerator } from "./components/drill-generator/DrillGenerator";
import PageViewDrill from "./components/page-view-drill/PageViewDrill";
import PageViewMatch from "./components/page-view-match/PageViewMatchV3";
import PageViewLeague from "./components/page-view-league";
import PageViewPlayer from "./components/page-view-player";
import PageEditPlayer from "./components/page-edit-player";
import PageViewTeam from "./components/page-view-team";
import PageTeamPreSeason from "./components/page-team-pre-season";
import PageAddLeague from "./components/page-new-league";
// import PageExerciseLibray from "./components/page-exercise-library";
import PageCoachLibrary from "./components/page-coach-library";
import PageNewTraining from "./components/page-new-training";
import PageViewExercise from "./components/page-view-exercise";
import PageViewTraining from "./components/page-view-training";
import PageViewScouting from "./components/page-view-scouting";
import PageValidateAccount from "./components/page-validate-account";
import PageViewProfile from "./components/views";
import PageMatches from "./components/page-matches";
import { BottomNavigationMUI } from "./components/bottom-navigation";
import UpdateNotification from "./components/update-notification/UpdateNotification";
import useAppUpdate from "./hooks/useAppUpdate";
import PageShareMatch from "./components/page-share-match";
import PageWorkspaceManagement from "./components/page-workspace-management/PageWorkspaceManagement";
import PageSetPassword from "./components/page-set-password";
import PageCoachRegistration from "./components/page-coach-registration";
// import PageCreateLinkPlayer from "./components/pages/create-and-link-player";

// navigator.serviceWorker.register("/sw.js");
// NOTE: This will be replaced by a real 404
/* istanbul ignore next */
const NotFound = (_: RouteComponentProps) => <Redirect to="/" noThrow />;

// Gestionar clase has-nav en #root para CSS padding
const useNavClass = (isLoggedIn: boolean) => {
  React.useEffect(() => {
    const root = document.getElementById('root');
    if (!root) return;
    if (isLoggedIn) {
      root.classList.add('has-nav');
    } else {
      root.classList.remove('has-nav');
    }
    return () => root.classList.remove('has-nav');
  }, [isLoggedIn]);
};

const App = () => {
  const [currentLocale] = useLocaleContext();
  const [{ isLoggedIn }] = useAuthContext();
  useNavClass(isLoggedIn);
  const { updateAvailable, applyUpdate } = useAppUpdate();
  const [updateDismissed, setUpdateDismissed] = React.useState(false);
  console.log("localeData");
  console.log(localeData);
  console.log((localeData as any)[currentLocale]);
  const messagesForLocale = (localeData as any)[currentLocale] || (localeData as any)["en"] || {};

  return (
    <>
      <CssBaseline />
      <UpdateNotification
        open={updateAvailable && !updateDismissed}
        onUpdate={applyUpdate}
        onClose={() => setUpdateDismissed(true)}
      />
      <>
        <IntlProvider
          locale={currentLocale}
          messages={messagesForLocale}
          defaultLocale="en_GB"
        >
          {/* <ResponsiveLayout disabled={isLoggedIn}> */}
          <ResponsiveLayout disabled={false}>
            <QueryParamProvider reachHistory={globalHistory}>
              <Router id="router">
                <NotFound default />
                <PageRegister path="/register/:registrationCode" />
                <PageRegister path="/register" />

                <PageValidateAccount path="/validate/:token" />
                
                {/* Public route for coach password setup */}
                <PageSetPassword path="/set-password" />
                
                {/* Public route for coach registration with QR/token invitation */}
                <PageCoachRegistration path="/register-coach" />
                
                {/* Public route for sharing match summaries */}
                <PageShareMatch path="/share-match/:id" />
                {/* <LoggedOutRoute component={PageRegister} path="/register/:token" /> */}
                <ProtectedRoute
                  component={PageNewPlayer}
                  path="/players/newplayer"
                />
                <ProtectedRoute
                  component={PageNewMatch}
                  path="/matches/newmatch"
                />

                <ProtectedRoute component={PageViewTeam} path="/teams/:id" />
                <ProtectedRoute
                  component={PageTeamPreSeason}
                  path="/teams/:id/pre-season"
                />
                <ProtectedRoute component={PageViewMatch} path="/matches/:id" />
                <ProtectedRoute
                  component={PageViewPlayer}
                  path="/players/:id"
                />
                <ProtectedRoute
                  component={PageEditPlayer}
                  path="/players/:id/edit"
                />
                <ProtectedRoute
                  component={PageViewPlayer}
                  path="/players/:id/information"
                />
                <ProtectedRoute
                  component={PageViewPlayer}
                  path="/players/:id/notes"
                />
                <ProtectedRoute
                  component={PageViewPlayer}
                  path="/players/:id/statistics"
                />
                <ProtectedRoute component={PageViewScouting} path="/scouting" />

                <ProtectedRoute component={PageNewTeam} path="/teams/newteam" />
                <ProtectedRoute
                  component={PageAddLeague}
                  path="/leagues/:id/addLeague"
                />
                <ProtectedRoute
                  component={PageViewLeague}
                  path="/leagues/:id"
                />
                <ProtectedRoute
                  component={PageViewLeague}
                  path="/leagues/:id/table"
                />
                <ProtectedRoute
                  component={PageViewLeague}
                  path="/leagues/:id/teams"
                />
                <ProtectedRoute
                  component={PageViewLeague}
                  path="/leagues/:id/matches"
                />
                <PageLogin path="/login" />
                <PageSendResetPassword path="/forgot-password" />
                <PageResetPassword path="/password/:token" />
                <ProtectedRoute component={PageUser} path="/user" />
                <ProtectedRoute
                  component={PageDashboard}
                  path="/dashboard"
                  withPermission={Permission.LEADERS_ADD}
                  unauthorizedRedirectTo="/people/players"
                />
                {/* <ProtectedRoute
                component={PageDashboard}
                path="/people/dashboard"
                withPermission={Permission.LEADERS_ADD}
                unauthorizedRedirectTo="/people/players"
              /> */}
                <ProtectedRoute component={PagePeople} path="/people/players" />
                <ProtectedRoute component={PagePeople} path="/people/teams" />
                <ProtectedRoute component={PageMatches} path="/people/matches" />

                {/* <ProtectedRoute
                component={PageExerciseLibray}
                path="/library"
                withPermission={Permission.LEADERS_ADD}
                unauthorizedRedirectTo="/dashboard"
              /> */}

                <ProtectedRoute
                  component={PageCoachLibrary}
                  path="/library/drills"
                  unauthorizedRedirectTo="/dashboard"
                />
                <ProtectedRoute
                  component={PageCoachLibrary}
                  path="/library/exercises"
                  unauthorizedRedirectTo="/dashboard"
                />
                <ProtectedRoute
                  component={PageCoachLibrary}
                  path="/library/trainings"
                />
                <ProtectedRoute
                  component={PageCoachLibrary}
                  path="/library/admin"
                />
                <ProtectedRoute
                  component={PageNewExercise}
                  path="/library/newdrill"
                />
                <ProtectedRoute
                  component={DrillGenerator}
                  path="/library/drills/ai-generator"
                />
                <ProtectedRoute
                  component={PageViewExercise}
                  path="/exercises/:id"
                />
                <ProtectedRoute
                  component={PageViewDrill}
                  path="/library/drills/:id"
                />
                <ProtectedRoute
                  component={PageNewTraining}
                  path="/library/newtraining"
                />
                <ProtectedRoute
                  component={PageViewTraining}
                  path="/trainings/:id"
                />
                <ProtectedRoute component={PageViewProfile} path="/profile" />
                <ProtectedRoute
                  component={PageWorkspaceManagement}
                  path="/workspace/:workspaceId"
                />
                {/* <ProtectedRoute
                  component={PageCreateLinkPlayer}
                  path="/users/:id/linkplayer"
                /> */}

                <Redirect noThrow from="/" to="/dashboard" />
              </Router>
            </QueryParamProvider>
            {isLoggedIn && <BottomNavigationMUI />}
          </ResponsiveLayout>
        </IntlProvider>
      </>
    </>
  );
};

export default App;
